import { z } from 'zod';
/**
 * Super-admin preview of a HubSpot company while linking it to a tenant: the
 * company basics, so the admin can confirm they entered the right id.
 */ export const ShowHubspotCompanyOverviewResponseSchema = z.object({
    companyId: z.string(),
    name: z.string().nullable(),
    domain: z.string().nullable(),
    industry: z.string().nullable(),
    /**
   * Das Firmenlogo aus HubSpot — das von Hand hochgeladene
   * (`hs_avatar_filemanager_key`), sonst das aus der Domain abgeleitete
   * (`hs_logo_url`). Wer eines hochlaedt, hat sich fuer genau dieses
   * entschieden; das abgeleitete bleibt daneben stehen und wuerde sonst
   * gewinnen.
   *
   * Gelesen statt gespeichert: es aendert sich, wenn die Firma ihre Website
   * wechselt, und eine Kopie bei uns waere die veraltete Fassung davon.
   */ logoUrl: z.string().nullable(),
    /**
   * Die Adresse, unter der ein Mensch diese Firma in HubSpot aufmacht.
   *
   * Aus dem Portal selbst gebaut, nicht eingestellt (siehe
   * `HubspotLinksService`): ein EU-Portal antwortet unter einer anderen
   * Domain, und die falsche zeigt nichts an. `null`, wo HubSpot nicht
   * eingerichtet ist oder gerade nicht antwortet.
   */ companyUrl: z.string().nullable(),
    /**
   * The Bliks tenant this company is already linked to (its `bliks_tenant_id`),
   * or null. Lets the dialog warn before overwriting an existing link.
   */ linkedTenantId: z.string().nullable(),
    /** Display name of {@link linkedTenantId}, when that tenant still exists. */ linkedTenantName: z.string().nullable()
});

//# sourceMappingURL=show-hubspot-company-overview.schema.js.map